module.exports = __webpack_public_path__ + "img/4_176.ee84646b.png";